import {
  POST_ORSG_COMPLEXES_UPDATE_PURCHASE,
  convertResult,
  convertParams,
} from 'app/common/api/requests/food/schools/complexes/update_purchases/post'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'

import {
  ComplexesUpdatePurchaseSuccess,
  ComplexesUpdatePurchaseParams,
} from 'app/dataTypes/org/complexes/updatePurchases'

const defaultState: ComplexesUpdatePurchaseSuccess = false

type Op = CommonDataOptions<ComplexesUpdatePurchaseSuccess, ComplexesUpdatePurchaseParams>

export function useUpdatePurchases(options: Op) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: POST_ORSG_COMPLEXES_UPDATE_PURCHASE,
    error: 'Не удалось обновить стоимость продаж комплекта на дату',
    convertions: {
      convertResult,
      convertParams,
    },
    defaultState,
  })

  return res
}
